import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  PigeonholePositionInfo,
  PigeonholePackage, PigeonholeOccupationInfo,
  PigeonholeMapPosition,
  PigeonholeDetailsResponse,
  PigeonholeMisplacedPallets,
  PigeonholeRowColumnResponse,
  PigeonholeGroup
} from 'src/models/Pigeonhole';

export interface PigeonholeGroupsResponse {
  count: number;
  values: PigeonholeGroup[];
}

@Injectable({
  providedIn: 'root'
})
export class PigeonholeService {

  constructor(private httpClient: HttpClient) { }

  async getPigeonholePositionMap(id: string) {
    return this.httpClient.get<PigeonholeMapPosition[]>(
      environment.v3BaseUrl + `/api/v3/admin-desktop/map/ground-positions/${id}/pigeonholes`
    ).toPromise();
  }

  async getPigeonholePositionInfo(id: string) {
    return this.httpClient.get<PigeonholePositionInfo>(environment.v3BaseUrl + `/api/v3/admin-desktop/ground-positions/${id}`).toPromise();
  }

  async getPigeonholePackages(id: string) {
    return this.httpClient.get<PigeonholePackage[]>(
      environment.v3BaseUrl + `/api/v3/admin-desktop/map/ground-positions/${id}/pigeonholes/packages`
    ).toPromise();
  }

  async getPigeonholeOccupationInfo(id: string) {
    return this.httpClient.get<PigeonholeOccupationInfo>(
      environment.v3BaseUrl + `/api/v3/admin-desktop/map/ground-positions/${id}/pigeonholes/dashboard`
    ).toPromise();
  }

  async getPigeonholeDetails(qrCode: string) {
    return this.httpClient.get<PigeonholeDetailsResponse>(
      environment.v3BaseUrl + `/api/v3/admin-desktop/pigeonholes/${qrCode}`
    ).toPromise();
  }

  async getPigeonholeMisplacedPallets(id: string) {
    return this.httpClient.get<PigeonholeMisplacedPallets[]>(
      environment.v3BaseUrl + `/api/v3/admin-desktop/ground-positions/${id}/pigeonholes/temp-inconsistent-pallets`
    ).toPromise();
  }

  async getPigeonholeRowOrColumnData(id: string, type: 'row' | 'column', coordinate: number) {
    let params = new HttpParams();
    const url = environment.v3BaseUrl + `/api/v3/admin-desktop/ground-positions/${id}/pigeonholes`;
    if (type === 'row') {
      params = params.set('row', String(coordinate));
    }
    if (type === 'column') {
      params = params.set('column', String(coordinate));
    }
    return this.httpClient.get<PigeonholeRowColumnResponse>(url, { params }).toPromise();
  }

  async getPigeonholeRowColumnOccupationInfo(id: string, type?: 'row' | 'column', coordinate?: number) {
    const url = environment.v3BaseUrl + `/api/v3/admin-desktop/map/ground-positions/${id}/pigeonholes/dashboard`;
    let params = new HttpParams();
    if (type === 'row') {
      params = params.set('row', String(coordinate));
    }
    if (type === 'column') {
      params = params.set('column', String(coordinate));
    }
    return this.httpClient.get<PigeonholeOccupationInfo>(url, { params }).toPromise();
  }

  async getPigeonholeGroups() {
    return this.httpClient.get<PigeonholeGroupsResponse>(
      environment.v3BaseUrl + `/api/v3/admin-desktop/pigeonhole-groups`
    ).toPromise();
  }
}
